/* eslint-disable no-console */
import { AnalyticsProvider, UserTraits } from "./types";

class AnalyticsService {
  private providers: AnalyticsProvider[] = [];

  registerProvider(provider: AnalyticsProvider): void {
    this.providers.push(provider);
  }

  identify(userId: string, traits?: UserTraits): void {
    this.providers.forEach((provider) => {
      try {
        provider.identify(userId, traits);
      } catch (error) {
        console.error(`[Analytics] ${provider.name} identify failed:`, error);
      }
    });
  }

  track(event: string, properties?: Record<string, any>): void {
    this.providers.forEach((provider) => {
      try {
        provider.track(event, properties);
      } catch (error) {
        console.error(`[Analytics] ${provider.name} track failed:`, error);
      }
    });
  }

  page(name?: string, properties?: Record<string, any>): void {
    this.providers.forEach((provider) => {
      try {
        provider.page(name, properties);
      } catch (error) {
        console.error(`[Analytics] ${provider.name} page failed:`, error);
      }
    });
  }

  reset(): void {
    this.providers.forEach((provider) => {
      try {
        provider.reset();
      } catch (error) {
        console.error(`[Analytics] ${provider.name} reset failed:`, error);
      }
    });
  }

  setUserProperties(properties: Record<string, any>): void {
    this.providers.forEach((provider) => {
      try {
        provider.setUserProperties?.(properties);
      } catch (error) {
        console.error(`[Analytics] ${provider.name} setUserProperties failed:`, error);
      }
    });
  }
}

// eslint-disable-next-line import/prefer-default-export
export const analytics = new AnalyticsService();
